module.exports = __webpack_public_path__ + "static/img/precess.27db64d3.png";